export const BAY_PRICING_SOURCE_VALUES = ['club', 'custom'];
export const BAY_PRICING_BASIS_VALUES = ['booking', 'person'];
export const BAY_START_MARK_VALUES = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
export const AUDIENCE_CLASS_VALUES = ['drop_in', 'membership', 'pass'];
export const DEFAULT_BAY_POLICY = Object.freeze({
    accessSchedule: null,
    coveredByPlans: true,
    pricingSource: 'club',
    customHourlyRateCents: null,
    pricingBasis: 'booking',
    startMarks: null,
});
//# sourceMappingURL=policy.js.map